// מראה של server/functions/emails.js בצד הלקוח.
// השרת הוא שאוכף; כאן זה רק כדי לסמן ולהתריע לפני שליחה.

export const ORG_DOMAINS = {
    mosad: 'bney.org.il',   // מוסדות ומנהלים
    meta: 'm-m.org.il',     // עובדי המטה
};

export const SCOPE_LABEL = {
    mosad: 'מוסד',
    meta: 'מטה',
};

export const normalize = (email) => (email || '').trim().toLowerCase();

// 'mosad' | 'meta' | null
export const classifyOrgEmail = (email) => {
    const value = normalize(email);
    const entry = Object.entries(ORG_DOMAINS).find(([, domain]) => value.endsWith('@' + domain));
    return entry ? entry[0] : null;
};

export const isOrgEmail = (email) => classifyOrgEmail(email) !== null;

export const orgDomainsHint =
    `חשבון ארגוני מסתיים ב-${ORG_DOMAINS.mosad} (מוסדות ומנהלים) או ב-${ORG_DOMAINS.meta} (עובדי המטה)`;

export const DEPARTMENTS = [
    { id: 1, name: 'ביטוחים' },
    { id: 2, name: 'כספים' },
    { id: 3, name: 'כח אדם' },
];

export const departmentName = (id) =>
    (DEPARTMENTS.find((d) => String(d.id) === String(id)) || {}).name || '';

// users.type
export const USER_TYPES = [
    { id: 2, name: 'בודק' },
    { id: 3, name: 'מחלקה' },
    { id: 4, name: 'מנהל מערכת' },
    { id: 5, name: 'דשבורד' },
];

export const userTypeName = (type) =>
    (USER_TYPES.find((t) => String(t.id) === String(type)) || {}).name ||
    (String(type) === '1' ? 'מנהל מוסד' : '');
